<template>
  <div
    class="modal fade"
    v-bind:id="texts.modalId"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document" >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            {{ texts.header }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click:
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">{{ texts.body }}</div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
            @click="$emit('confirm', $event)"
          >
            {{ texts.confirm }}
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$emit('reject', $event)"
          >
            {{ texts.reject }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["settings"],
  data: function () {
    return {
      texts: {
        modalId: this.settings.modalId || "default",
        header: this.settings.header || "Potwierdzenie",
        body: this.settings.body || "Czy jesteś pewny, że chcesz usunąć rekord?",
        confirm: this.settings.confirm || "TAK",
        reject: this.settings.reject || "NIE"
      },
    };
  },
};
</script>